export const GET_STORES_ORGANIZATION = 'stores/GET_STORES_ORGANIZATION';
export const GET_STORES_ORGANIZATION_SUCCESS = 'stores/GET_STORES_ORGANIZATION_SUCCESS';
export const GET_STORES_ORGANIZATION_FAILED = 'stores/GET_STORES_ORGANIZATION_FAILED';
export const GET_STORE= 'stores/GET_STORE';
export const GET_STORE_SUCCESS = 'stores/GET_STORE_SUCCESS';
export const GET_STORE_FAILED = 'stores/GET_STORE_FAILED';
export const EDIT_STORE = 'stores/EDIT_STORE';
export const EDIT_STORE_SUCCESS = 'stores/EDIT_STORE_SUCCESS';
export const EDIT_STORE_FAILED = 'stores/EDIT_STORE_FAILED';